<template>
  <base-container>
    <tip />
  </base-container>
</template>

<script>
import { createPage } from '@mpxjs/core'

createPage({
})
</script>

<style lang="stylus">

</style>

<script type="application/json">
  {
    "usingComponents": {
      "base-container": "../../components/base-container/index",
      "tip": "./tip"
    }
  }
</script>
